export { default as Details } from './Details/Details';
export { default as Button } from './Button/Button';
export { default as Table } from './Table/Table';
